export default __webpack_public_path__ + "static/media/m-qs-banner3.cd973eef.png";